
/* eslint-disable */
import { Prop, Watch } from "vue-property-decorator";
import { Options, Vue } from "vue-class-component";
import Slider from "@/components/ui/Slider.vue";
import KeyframeList from "@/components/KeyframeList.vue";
import * as d3 from "d3";
import * as ColorPreset from "@/assets/color-preset";
import { createColorPicker } from "@/assets/color-picker";
import { FontConfig } from "@/assets/variable-font";
import { KeyframeConfig, GroupManagerConfig, Word } from "@/assets/types";
import { GroupManager } from "@/assets/animator"
@Options({
  components: {
    Slider,
    KeyframeList
  },
})
export default class GroupPanel extends Vue {
  @Prop({}) public group: GroupManagerConfig = new GroupManager({})
  @Prop({}) public font: FontConfig = new FontConfig()
  @Prop({}) public groupIndex: number = 0
  private colorScheme: Array<string> = ColorPreset.exciting
  private delay: number = 0
  private duration: number = 2000
  get wordContent(): Array<string> {
    if(!this.group) return []
    return this.group.words.map((v: Word) => v.text || "")
  }
  get keyframes(): Array<KeyframeConfig> {
    if(!this.group) return []
    return this.group.keyFrames
  }
  created() { 
    
  }
  mounted() {
    // let colors = this.colorScheme
    //  this.colorScheme.forEach((c, idx) => {
    //   createColorPicker(c, colors, `#color_${this.groupIndex}_${idx}`)
    // })
  }
  @Watch("group")
  public groupChanged(val: GroupManagerConfig): void {
    console.log(val, 'nonono')
     let colors = this.colorScheme
     this.colorScheme.forEach((c, idx) => {
      createColorPicker(c, colors, `#color_${this.groupIndex}_${idx}`)
    })
  }
  wghtCallback(v: number) {
    this.font.setValWithRatio("weight", v);
  }
  italCallback(v: number) {
    this.font.setValWithRatio("italic", v);
  }
  widhCallback(v: number) {
    this.font.setValWithRatio("width", v);
  }
  durationCallback(v: number) {
    this.duration = v;
  }
  delayCallback(v: number) {
    this.delay = v;
  }
}
